// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BEFM4","image":"styles_image__3jHNd","title":"styles_title__j9Xs1","icon":"styles_icon__38u-C"};